let content_blocks = require('../contents');
let calendars = [];

export function init(){

    $('#edit_calendar_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#add_calendar_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="block_id"]').val(block.attr('id'));
    });

    $('#edit_calendar_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

    });

    $('#add_calendar').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        let select = $('#add_calendar .x-form-input select');
        add_data_elements(select, block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');
    });

    $('#edit_calendar').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        
        content_blocks.change_visible_button_blocks(block);
        let modal = $(this).closest('.modal');
        modal.modal('hide');
    });

    init_table_entries();

    $('.block[data-type="calendar"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}

export function add_data_elements(select , block) {
    
    let elements = JSON.parse(block.attr('data-elements'));
    if(typeof elements[select.val()] == 'undefined'){
        elements[select.val()] = select.find('option:selected').text();
        block.attr('data-elements', JSON.stringify(elements));

        init_table_entries(block);
    }
}

export function filter_calendars(data) {

    let results = $.map(data.results, function(obj, calendar) {
        return { 
            id: obj.id, 
            text: obj.name,
            result: obj.name
        };
    });

    return {
        results: results
    };
}

function init_table_entries(block) {
    let blocks = block ? block : $('.block[data-type="calendar"]');
    
    blocks.each(function(){

        let table = $(this).find('table');
        let tbody = $(this).find('tbody');        

        let calendars = JSON.parse($(this).attr('data-elements'));
        
        let rows = '';
        for(const id in calendars){
            if(calendars[id] != null){
                rows += '<tr data-id="' + id + '">'+
                    '<td style="max-width: 10px"><button type="button" class="btn btn-xs btn-danger delete"><i class="fa-solid fa-trash"></i></button> ' + calendars[id] + '</td>'+
                '</tr>';       
            }
        }
        
        tbody.html(rows);
        init_entries_actions(table);
    });
}

function init_entries_actions(table) {

    table.find('.btn.delete').on('click', function(){
            
        let tr = $(this).closest('tr');
        let calendar_id = tr.attr('data-id');
        let block = tr.closest('.block');
        
        let elements = JSON.parse(block.attr('data-elements'));
        
        delete elements[calendar_id];
        
        block.attr('data-elements', JSON.stringify(elements));
        tr.remove();
    });
}